<template>
    <div class="grid">
        <p class="font-size-sm mb-0">
            {{ streetAddress }}
        </p>
        <p class="font-size-sm mb-0">
            {{ postalCode_City }}
        </p>
    </div>
</template>

<script>
export default {
  name: "AddressCell.vue",
  props: {
    cellProps: {
      type: Object
    },
    row: {
      type: Object,
      required: true
    },
  },
    computed:{
      customer(){
        return this.row;
      },
      property(){
        return this.cellProps || {};
      },
      streetAddress(){
        return (this.property.street ? this.property.street + ' ' : '') + (this.property.number ? this.property.number : '') + (this.property.number_addition ? this.property.number_addition : '');
      },
      postalCode_City(){
        return (this.property.postal_code ? this.property.postal_code + ' ' : '') + (this.property.city ? this.property.city : '');
      }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
